import React from 'react';

const Logo = ({ className }) => {
  return (
    <svg 
      width="85" 
      height="84" 
      viewBox="0 0 85 84" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      <rect width="85" height="83.172" rx="22" fill="url(#paint0_linear_168_3592)"/>
      
      {/* Ліве око */}
      <g className="eye-left">
        <path d="M21.7892 60.244L21.7814 60.2439C12.8242 60.1584 5.63228 52.8279 5.71776 43.8707L5.74579 40.9332C5.83127 31.976 13.1618 24.784 22.119 24.8695L22.1268 24.8696C31.084 24.955 38.276 32.2856 38.1905 41.2428L38.1625 44.1803C38.077 53.1375 30.7464 60.3295 21.7892 60.244Z" fill="#FFFBF7" stroke="#1E1E1E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.912 52.9123C17.8776 52.8738 14.6514 48.1943 14.7061 42.4603C14.7609 36.7263 18.0757 32.1092 22.1101 32.1477C26.1445 32.1862 29.3707 36.8657 29.316 42.5997C29.2612 48.3337 25.9464 52.9508 21.912 52.9123Z" fill="#1E1E1E" stroke="#1E1E1E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M19.8104 30.8207L22.5142 39.0536L13.0017 37.4007L19.8104 30.8207Z" fill="#FFFBF7"/>
      </g>

      {/* Праве око (анімоване) */}
      <g className="eye-right-wink">
        <path d="M63.5968 60.244L63.5891 60.2439C54.6319 60.1584 47.4399 52.8279 47.5254 43.8707L47.5534 40.9332C47.6389 31.976 54.9694 24.784 63.9266 24.8695L63.9344 24.8696C72.8916 24.955 80.0836 32.2856 79.9981 41.2428L79.9701 44.1803C79.8846 53.1375 72.554 60.3295 63.5968 60.244Z" fill="#FFFBF7" stroke="#1E1E1E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M63.7198 52.9123C59.6854 52.8738 56.4593 48.1943 56.514 42.4603C56.5687 36.7263 59.8836 32.1092 63.918 32.1477C67.9524 32.1862 71.1785 36.8657 71.1238 42.5997C71.0691 48.3337 67.7542 52.9508 63.7198 52.9123Z" fill="#1E1E1E" stroke="#1E1E1E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M61.6181 30.8207L64.3218 39.0536L54.8093 37.4007L61.6181 30.8207Z" fill="#FFFBF7"/>
      </g>

      {/* Вуха */}
      <path d="M9.803 12.8502L22.5728 10.7605C25.0464 10.3557 27.3799 12.0329 27.7847 14.5066L27.9592 15.5726C28.364 18.0463 26.6868 20.3798 24.2131 20.7846L11.4434 22.8743C8.9697 23.2791 6.63623 21.6019 6.23142 19.1282L6.05697 18.0622C5.65216 15.5885 7.32932 13.255 9.803 12.8502Z" fill="#FFFBF7" stroke="#1E1E1E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M75.9509 12.8503L63.1811 10.7606C60.7075 10.3558 58.374 12.0329 57.9692 14.5066L57.7947 15.5727C57.3899 18.0464 59.0671 20.3798 61.5408 20.7846L74.3105 22.8743C76.7842 23.2791 79.1177 21.602 79.5225 19.1283L79.6969 18.0622C80.1017 15.5885 78.4246 13.2551 75.9509 12.8503Z" fill="#FFFBF7" stroke="#1E1E1E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      
      {/* Рот */}
      <path d="M42.253 70.7438C33.9271 70.7438 31.4805 64.6579 31.5718 61.8091H53.482C53.482 64.1399 52.6604 70.7438 42.253 70.7438Z" fill="#F1F458" stroke="#1E1E1E" strokeWidth="1.2"/>
      <path d="M42.5271 51.5147C32.2293 51.5147 28.0116 57.6007 27.1899 60.6437L42.801 64.3341L58.412 60.6437C57.4078 57.6007 52.8249 51.5147 42.5271 51.5147Z" fill="#F1F458" stroke="#1E1E1E" strokeWidth="1.2"/>

      <defs>
        <linearGradient id="paint0_linear_168_3592" x1="42.5" y1="0" x2="42.5" y2="83.172" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7979F6"/>
          <stop offset="1" stopColor="#5B5BD8"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;